import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import iziToast from 'izitoast';
import Swal from 'sweetalert2';
import { ServiceService } from '../services/service.service';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
declare var $: any
import * as html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-invoice-payment',
  templateUrl: './invoice-payment.component.html',
  styleUrls: ['./invoice-payment.component.css']
})
export class InvoicePaymentComponent implements OnInit {

  @ViewChild('invoiceContainer', { static: false }) invoiceElement!: ElementRef;
  planName: any;
  planPrice: any;
  user_id: any;
  api_version: any;
  client_id: any;
  nas_id: any;
  ps_key: any;
  post_code: any;
  expiredDate: any;
  // profile
  userdetails: any[] = [];
  getvalue: any;
  city: any;
  streetAddress: any;
  addressOnly: any;

  // dates
  startDate: any;
  endDate: any;
  time: any;
  invoice_no: any;

  // qr 
  isProcessing = false;
  paymentURL: any;
  showQRModal = false;
  public stringQrCode: string = null;
  private overlay: HTMLElement | null = null;
  // download invoice 

  isDownloading = false;
  pdfUrlBlob: any;
  paid_amount: any;
  invoice_ID: any;
  invoice_NO: any;
  constructor(private serviceservice: ServiceService, private location: Location, private router: Router, private route: ActivatedRoute, private renderer: Renderer2, private http: HttpClient) {

  }

  ngOnInit(): void {

    this.user_id = localStorage.getItem('user_name');
    this.api_version = localStorage.getItem('api_version');
    this.client_id = localStorage.getItem('client_id');
    this.nas_id = localStorage.getItem('nas_id');
    this.ps_key = localStorage.getItem('ps_key');
    this.expiredDate = localStorage.getItem('expiredDate');

    this.route.queryParams.subscribe(params => {
      this.planName = params['plan_name'];
      this.planPrice = params['plan_price'];

      // console.log(this.planName, this.planPrice);
    });


    this.postData();

    const start = new Date(this.expiredDate); // Parses "Aug 23, 2025 23:59:59"
    start.setDate(start.getDate() + 1);
    const end = new Date(start);
    end.setDate(start.getDate() + 30);

    this.startDate = this.formatDate(start);
    this.endDate = this.formatDate(end);

    // const today = new Date();
    // const end = new Date();
    // end.setDate(today.getDate() + 30);

    // this.startDate = this.formatDate(today);
    // this.endDate = this.formatDate(end);
    const now = new Date();
    this.time = now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0');
    this.invoice_no = Math.floor(100000 + Math.random() * 900000).toString();


    this.getUaerPlanDetails()
  }

  loaderStart() {
    // Create overlay and loader only when API is called
    this.overlay = this.renderer.createElement('div');
    const loader = this.renderer.createElement('div');

    this.renderer.addClass(this.overlay, 'overlay');
    this.renderer.addClass(loader, 'loader');

    loader.innerHTML = 'Loading...'; // Optional text

    this.renderer.appendChild(this.overlay, loader);
    this.renderer.appendChild(document.body, this.overlay);
  }

  loaderEnd() {
    this.renderer.removeChild(document.body, this.overlay);
  }

  formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  paymentProcess(planName: any) {


    let planPrice = $('#total_price').text().replace('₹', '').replace(/,/g, '');

    const paymentData = {
      user_id: this.user_id,
      amount: planPrice,
      plan_name: planName,
    };

    this.serviceservice.processPayment(paymentData).subscribe(
      (response) => {
        //console.log('Payment Success:', response);
      },
      (error) => {
        //console.error('Payment Error:', error);
      }
    );
  }

  payment_invoice_update() {


    var user_id = (document.getElementById('phone') as HTMLElement)?.innerText || '';
    var user_name = (document.getElementById('user_name') as HTMLElement)?.innerText || '';
    var plan_name = (document.getElementById('plan_name') as HTMLElement)?.innerText || '';
    var plan_charges = (document.getElementById('plan_price') as HTMLElement)?.innerText.replace('₹', '').trim() || '0';
    var other_charges = (document.getElementById('other_price') as HTMLElement)?.innerText.replace('₹', '').trim() || '0';
    var taxes_GST_18 = (document.getElementById('gst')?.querySelector('.price') as HTMLElement)?.innerText.replace('₹', '').trim() || '0';
    var total_price = (document.getElementById('total_price') as HTMLElement)?.innerText.replace('₹', '').trim() || '0';
    var invoice_no = (document.getElementById('invoice_no') as HTMLElement)?.innerText.replace('INVOICE NO:', '').trim() || '';
    var invoice_date = (document.getElementById('invoive_date') as HTMLElement)?.innerText.replace('INVOICE DATE:', '').trim() || '';
    var time_delivered = (document.getElementById('time_dilivery') as HTMLElement)?.innerText.replace('TIME DELIVERED:', '').trim() || '';
    var start_date = (document.getElementById('start_date') as HTMLElement)?.innerText.replace('Start Date :', '').trim() || '';
    var end_date = (document.getElementById('end_date') as HTMLElement)?.innerText.replace('End Date :', '').trim() || '';
    var address = (document.getElementById('address') as HTMLElement)?.innerText || '';
    var city = (document.getElementById('city') as HTMLElement)?.innerText || '';


    const api_req: any = {
      action: "payment_invoice",
      phone_number: user_id,
      user_id: user_id,
      user_name: user_name,
      plan_name: plan_name,
      plan_charges: plan_charges,
      other_charges: other_charges,
      taxes_GST_18: taxes_GST_18,
      total_price: total_price,
      invoice_no: invoice_no,
      invoice_date: invoice_date,
      time_delivered: time_delivered,
      start_date: start_date,
      end_date: end_date,
      address: address + ' ' + city,

    };

    this.serviceservice.processPayment(api_req).subscribe((response: any) => {
      if (response.success == true || response.success == "true") {
        // success handling
        iziToast.success({
          message: 'Payment successfully',
          position: 'topRight'
        });
        //console.log("invoice update successfully");
        //  this.router.navigate(['/payment-success']);

        this.router.navigate(['/payment-success'], {
          queryParams: {
            current_user_id: user_id,
            current_plan_name: plan_name,
            current_plan_price: total_price,
          }

        });;

      } else {
        // error handling
        console.error("invoice update failed");
      }
    });
  }
  formatDate1(input: string): string {
    const date = new Date(input);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }


  cancel() {

    this.location.back();
  }


  postData() {
    const body = new HttpParams()
      // .set('api_version', this.api_version)
      // .set('client_id', this.client_id)
      // .set('ps_key', this.ps_key)
      // .set('nas_id', this.nas_id)
      .set('action_id', 'get_user_record')
      .set("action", "get_url")
      .set('req_params', JSON.stringify({ req_id: 'string', user_id: this.user_id }));

    // Set headers
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    this.serviceservice.sendServer2(body.toString(), headers).subscribe(
      (response: any) => {
        // console.log('API Response:', response);

        if (response && response.results) {

          this.userdetails = Array.isArray(response.results) ? response.results : [response.results];
          // console.log(this.userdetails);

          this.extractAddressCity(response.results.address);
        } else {
          console.error('Results not found in response:', response);

        }
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
  }


  extractAddressCity(address: string) {
    let parts = address.split(",");

    if (parts.length >= 2) {

      this.city = parts[parts.length - 1];
      // console.log("length:", parts.length);
      this.addressOnly = address.replace(',' + parts[parts.length - 1], "")

    }
    else {
      this.addressOnly = address;
      this.city = "Unknown";
    }
    // console.log("Address:", this.addressOnly);
    // console.log("City:", this.city);
  }

  getUaerPlanDetails() {
    var data: any = new FormData();
    // data.append("api_version", this.api_version);
    // data.append("client_id", this.client_id);
    // data.append("ps_key", this.ps_key);
    // data.append("nas_id", this.nas_id);
    data.append("action_id", "get_user_id_plan_details");
    data.append("action", "get_url");
    data.append("req_params", JSON.stringify({ user_id: this.user_id }));

    var self = this;
    $.ajax({
      type: "POST",

      url: "https://chettinadlink.com/zoho-apis/",
      cache: false,
      contentType: false,
      processData: false,
      data: data,

      success: function (result: any) {
        if (result.message == "success") {
          if (result.results) {
            const userPlan = result.results;
            self.post_code = userPlan.post_code;

          } else {
            console.error("No plan details found for the user.");

          }
        }
      }
    });

  }


  paymentSubmit() {

    // if (this.renewalForm.get('account_state')?.value !== 'expired') {
    //   console.warn('Cannot submit — Account state is not expired.');
    //   return;
    // }


    Swal.fire({
      title: 'Are you sure to Renewal Payment?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Renewal it!'
    });

    let planPrice = $('#total_price').text().replace('₹', '').replace(/,/g, '');

    var data: any = new FormData();
    // data.append("api_version", this.api_version);
    // data.append("client_id", this.client_id);
    // data.append("ps_key", this.ps_key);
    // data.append("nas_id", this.nas_id);
    data.append("action_id", "post_ve_payment_to_user_id");
    data.append("action", "get_url");
    data.append("req_params", JSON.stringify({ "user_id": this.user_id, "total_amount": planPrice, "renew_type": "normal", "post_code": this.post_code, "discount_coupon_code": "", "order_id": "1234" }));

    for (let pair of data.entries()) {
      //console.log(pair[0] + ':', pair[1]);
    }
    return false;

    var self = this;
    $.ajax({
      type: "POST",

      url: "https://chettinadlink.com/zoho-apis/",
      cache: false,
      contentType: false,
      processData: false,
      data: data,

      success: function (result: any) {

        if (result.success == true || result.success == "true") {
          // Handle success response
          //  console.log("Payment successful:", result.message);
          iziToast.success({
            message: result.message,
            position: 'topRight'
          });
          window.location.reload();
        }
        else {
          // Handle error response
          iziToast.error({
            message: result.message,
            position: 'topRight'
          });
        }
      }
    });



  }

  qrOpen(url: any) {

    this.stringQrCode = url;

    this.showQRModal = true;
  }


  downloadBlobPDF(invoiceID: any, invoiceNumber: any) {
    const api_req: any = {
      action: "download_invoice",
      invoice_id: invoiceID,
      invoice_number: invoiceNumber,
    };

    this.isDownloading = true;

    this.serviceservice.sendzohoServer(api_req).subscribe({
      next: (response: any) => {
        if (response.success === true || response.success === 'true') {
          const pdfUrl = response.data;

          this.http.get(pdfUrl, { responseType: 'arraybuffer' }).subscribe({
            next: (pdfData) => {
              const blob = new Blob([pdfData], { type: 'application/pdf' });
              const blobUrl = URL.createObjectURL(blob);
              window.open(blobUrl, '_blank');

              this.isDownloading = false;
            },
            error: (err) => {
              console.error('PDF view failed:', err);
              iziToast.error({
                message: 'Failed to view PDF.',
                position: 'topRight'
              });
              this.isDownloading = false;
            }
          });

        } else {
          iziToast.error({
            message: 'Invoice not found.',
            position: 'topRight'
          });
          this.isDownloading = false;
        }
      },
      error: (err) => {
        console.error('API error:', err);
        iziToast.error({
          message: 'Server error while requesting invoice.',
          position: 'topRight'
        });
        this.isDownloading = false;
      }
    });
  }

  downloadInvoice(invoiceId: string, invoiceNumber: string) {
    this.loaderStart();
    fetch('https://chettinadlink.com/zoho-apis/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        action: 'download_invoice',
        invoice_id: invoiceId,
        invoice_number: invoiceNumber
      })
    })
      .then(response => {
        if (!response.ok) {
          this.loaderEnd();
          throw new Error("Failed to download invoice");

        }
        return response.blob();
      })
      .then(blob => {
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `invoice_${invoiceNumber}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(downloadUrl);
        this.loaderEnd();
      })
      .catch(err => {
        alert("Error: " + err.message);
        console.error("Download error:", err);
        this.loaderEnd();
      });
  }


  createInvoice() {

    this.loaderStart();
    this.isProcessing = true;
    const formatDate = (dateStr: string): string => {
      const parts = dateStr.split('/');
      if (parts.length === 3) {
        const [day, month, year] = parts;
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      }
      return '';
    };
    var plan_name = (document.getElementById('plan_name') as HTMLElement)?.innerText || '';
    var user_id = (document.getElementById('phone') as HTMLElement)?.innerText || '';
    const invoice_date = (document.getElementById('invoive_date') as HTMLElement)?.innerText.replace('INVOICE DATE:', '').trim() || '';
    const plan_charges = (document.getElementById('plan_price') as HTMLElement)?.innerText.replace('₹', '').replace(/,/g, '').trim() || '0';
    const total_price = (document.getElementById('total_price') as HTMLElement)?.innerText.replace('₹', '').replace(/,/g, '').trim() || '0';
    const start_date_raw = (document.getElementById('start_date') as HTMLElement)?.innerText.replace('Plan Start Date :', '').trim() || '';
    const end_date_raw = (document.getElementById('end_date') as HTMLElement)?.innerText.replace('Plan End Date :', '').trim() || '';

    const start_date = formatDate(start_date_raw);
    const end_date = formatDate(end_date_raw);

    const api_req: any = {
      action: "create_invoice",
      phone_number: this.user_id,
      plan_name: plan_name,
      date: start_date,
      end_date: end_date,
      sub_total: plan_charges,
      total: total_price,
    };

    this.serviceservice.sendzohoServer(api_req).subscribe({
      next: (response: any) => {
        if (response.data === 1 || response.data === "1") {
          this.paymentURL = response.payment_url;
          this.qrOpen(this.paymentURL);
          this.loaderEnd();
        } else if (response.data === 2 || response.data === "2") {

          // this.downloadBlobPDF(response.invoice_id, response.invoice_number)
          this.paid_amount = response.payment_status;
          this.invoice_ID = response.invoice_id;
          this.invoice_NO = response.invoice_number;
          this.loaderEnd();

        }
        else {
          iziToast.error({
            message: 'Server error. Please contact support.',
            position: 'topRight'
          });
          this.loaderEnd();
        }
      },
      error: (err) => {
        console.error('Invoice API error:', err);
        iziToast.error({
          message: 'Server error. Please contact support.',
          position: 'topRight'
        });
        this.loaderEnd(); // Remove loader
      },
      complete: () => {
        this.isProcessing = false;
      }
    });
  }



  payNow() {
    window.open(this.paymentURL, '_blank');
    // this.showQRModal = false;
  }





}
